import { ReactChild, ReactNode } from 'react';

export namespace PageTitleTypes {
  export interface IPageTitle {
    RenderAs?: TPageTitleRenderAs;
    children: ReactChild | ReactNode[] | any;
  }
  export type TPageTitleRenderAs = 'h1';
}
